import TuneIcon from '@material-ui/icons/Tune'
import { GoalWizardSideBarShell } from 'components/GoalWizard'

import { BulkGoalClasses } from '../../types'

interface BulkGoalsSideBarProps {
  allStoreCommissionFilled: boolean
  allStoreGoalsFilled: boolean
  allStoreValuesFilled: boolean
  classes: BulkGoalClasses
  selectedMonth: string
  selectedMonthLabel: string
  selectedStoresCount: number
  storeGoalConfigsCount: number
  totalSelectedSellers: number
}

const BulkGoalsSideBar = ({
  allStoreCommissionFilled,
  allStoreGoalsFilled,
  allStoreValuesFilled,
  classes,
  selectedMonth,
  selectedMonthLabel,
  selectedStoresCount,
  storeGoalConfigsCount,
  totalSelectedSellers
}: BulkGoalsSideBarProps) => (
  <GoalWizardSideBarShell>
    <div className={classes.sideTopInfo}>
      <div>
        <TuneIcon style={{ marginRight: 5, color: '#546e7a' }} fontSize='small' />
        <span>Metas para</span>
      </div>
      <strong>{selectedStoresCount || '...'} lojas</strong>
    </div>

    <div className={classes.sideSection}>
      <h2>Meta para {selectedMonthLabel !== '-' ? selectedMonthLabel.split(' - ')[0] : '...'}</h2>
      <span className={selectedMonth ? 'filled' : ''}>{selectedMonth ? selectedMonthLabel : '(?) Mês da meta'}</span>
      <span className={selectedStoresCount ? 'filled' : ''}>
        {selectedStoresCount ? `${selectedStoresCount} lojas selecionadas` : '(?) Lojas selecionadas'}
      </span>
    </div>

    <div className={classes.sideSection}>
      <h2>Comissão</h2>
      <span className={allStoreCommissionFilled ? 'filled' : ''}>
        {allStoreCommissionFilled ? `${storeGoalConfigsCount} lojas configuradas` : '(?) Configuração por loja'}
      </span>
    </div>

    <div className={classes.sideSection}>
      <h2>Valores</h2>
      <span className={allStoreValuesFilled ? 'filled' : ''}>
        {allStoreValuesFilled ? `${storeGoalConfigsCount} lojas com valores definidos` : '(?) Meta da loja'}
      </span>
    </div>

    <div className={classes.sideSection}>
      <h2>Perfis</h2>
      <span className={allStoreGoalsFilled ? 'filled' : ''}>
        {allStoreGoalsFilled ? `${storeGoalConfigsCount} lojas com metas` : '(?) Metas por loja'}
      </span>
    </div>

    <div className={classes.sideSection}>
      <h2>Equipe</h2>
      <span className={selectedStoresCount ? 'filled' : ''}>
        {selectedStoresCount ? `${totalSelectedSellers} vendedores` : '(?) Vendedores nas metas'}
      </span>
    </div>
  </GoalWizardSideBarShell>
)

export default BulkGoalsSideBar
